import { displayAds } from "./display"
import { initializeResponsiveAds } from "./initialize"

window.addEventListener("resize", () => {
  initializeResponsiveAds()
  displayAds()
})
